import CopyableField from "components/CopyableField";
import { useFormContext, useWatch } from "react-hook-form";
import { NEXT_FRONTEND_URL } from "utils/constants";

export function WebhookPostSection(): JSX.Element | null {
  const webhookSlug = useWatch({ name: "webhookSlug" });
  return (
    <>
      <div>
        <div className="text-gray-900">Trigger a signal on Avenue by sending POST request to a Webhook URL.</div>

        {webhookSlug ? (
          <div className="pt-3.5">
            <div className="font-medium text-gray-900 text-sm">Webhook to post to</div>
            <CopyableField className="mb-4" value={`${NEXT_FRONTEND_URL}/api/trigger/${webhookSlug}`} />
          </div>
        ) : null}
      </div>
    </>
  );
}
